import { Box, Stack, Typography } from "@mui/material";
import { useEventInfoStore } from "../../store/layerStore";

const MORE_ABOUT_EVENT_KEY = 'MORE_ABOUT_EVENT';

const getMoreAboutEventContent = (menuOptions: Array<{ key?: string; label?: string; url?: string; title?: string }> | undefined) => {
    const item = menuOptions?.find((m) => m.key === MORE_ABOUT_EVENT_KEY);
    const title = item?.label || item?.title || '';
    const url = item?.url || '';

    return { title, url };
}

export default function PreWrit(props: {minHeight?:string}) {
    const { eventInfo } = useEventInfoStore();
    var { title, url } = getMoreAboutEventContent(eventInfo?.menuOptions as Array<{ key?: string; label?: string; url?: string; title?: string }> | undefined);
    const hasContent = title.length > 0 && url.length > 0;
    title = "Voting places for the 2026 Provincial General Election are being confirmed and will be posted here when available.";
    url = "https://elections.bc.ca/";
    return (
        <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight={`calc(100vh - 128px)`}
        >
            <Stack direction='column' alignItems='center' margin='10%'>
                {hasContent ? (
                    <>
                        <Typography align="center" paragraph variant="h4">A Provincial General Election has been called. </Typography>
                        <Typography align="center" paragraph variant="h5">{title}</Typography>
                        {/* <Typography paragraph align="center" variant="h5">
                            <a href={url} target="_blank" rel="noreferrer">{url}</a>
                        </Typography> */}
                    </>
                ) : (
                    <Typography align="center" paragraph variant="h5">
                        Information about the current event is unavailable. Visit <a href="https://elections.bc.ca/" target="_blank" rel="noreferrer">https://elections.bc.ca/</a>.
                    </Typography>
                )}
                {/* <Typography align="center" paragraph variant="h4">The 2026 Provincial General Election is scheduled for Saturday, October 24, 2026. Voting places for the election will be published here when available.</Typography>
                <Typography paragraph align="center" variant="h5">See the <a href="https://elections.bc.ca/2026-provincial-election/" target="_blank" rel="noreferrer">2026 Provincial Election</a> page for  more information.</Typography> */}
            </Stack>
        </Box>
    );
}